import client from './client'
import qs from 'qs'
import apiUrlDeal from '../api-urls/apiUrlDeal'
/*
* params
*   type
*   url
*   data
* */
export default function ([apiName, ...apis], params = {}) {
  const apiUrl = apiUrlDeal(apiName, apis)
  Object.assign(params, apiUrl)
  const type = params.type ? params.type.toUpperCase() : 'GET'
  const data = params.data || {}
  const headers = params.headers || {}
  const {url} = params
  switch (type) {
    case 'GET':
      return client.get(url, {
        params: data,
        headers,
        paramsSerializer: (params) => {
          return qs.stringify(params, {indices: false})
        }
      })
    case 'POST':
      return client.post(url, data, { headers })
    case 'PUT':
      return client.put(url, data, { headers })
    case 'DELETE':
      return client.delete(url, data, { headers })
  }
}



// WEBPACK FOOTER //
// ./src/apis/root-api/api.js